import React, { useEffect } from "react";
import PropTypes from "prop-types";

const FILTERS_LS_KEY = "FILTERS";

/*
* How to use withFilters.
* Step 1:
*
export default withFilters(connect(
  mapStateToProps,
  mapStateToDispatch
)(Filers))
*
* Step 2:
<Filters
  name={FILTERS_KEY} <----
  activeFilters={filters}
  totalCount={list.total_count || 0}
  handleSearch={handleSearch}
  handleReset={handleReset}
/>
*
* step 3:
*
... = useSearchHook(getSearch, {
    size: 20,
    sort: "lastUpdatedAt,desc",
    name: FILTERS_KEY <----
  });
*/

export const getSavedFilters = (filtersName) => {
  try {
    const filters = JSON.parse(localStorage.getItem(FILTERS_LS_KEY));
    if (!filters) {
      return [];
    }
    if (!filters[filtersName]) {
      return [];
    }
    return filters[filtersName];
  } catch (e) {
    return [];
  }
};

// eslint-disable-next-line react/display-name
const withFilters = Component => props => {
  const {
    name,
    activeFilters
  } = props;

  useEffect(() => {
    if (name) {
      if (!localStorage.getItem(FILTERS_LS_KEY)) {
        localStorage.setItem(FILTERS_LS_KEY, JSON.stringify({
          [name]: {}
        }));
      }
      const existingFilters = JSON.parse(localStorage.getItem(FILTERS_LS_KEY));
      existingFilters[name] = activeFilters;
      localStorage.setItem(FILTERS_LS_KEY, JSON.stringify({
        ...existingFilters,
        [name]: activeFilters
      }));
    }
  }, [activeFilters, name]);

  return <Component {...props} activeFilters={activeFilters}/>;
};

withFilters.propTypes = {
  name: PropTypes.string.isRequired,
  filters: PropTypes.object.isRequired,
};

export default withFilters;



// WEBPACK FOOTER //
// ./src/views/lib/HOC/withFilters.js